import { AsYouType, isValidPhoneNumber as libIsValid, getExampleNumber } from "libphonenumber-js";
import examples from "libphonenumber-js/mobile/examples";

export const formatPhoneNational = (val: string, country: string, phoneCode?: string) => {
  let clean = val;
  // If phoneCode is provided, strip it if the user pasted/typed it
  if (phoneCode) {
    const code = phoneCode.replace("+", "").trim();
    const cleanVal = val.replace("+", "").trim();
    if (cleanVal.startsWith(code)) {
      clean = cleanVal.substring(code.length);
    }
  }

  // Count digits
  const digits = clean.replace(/\D/g, "");

  // Define maximum digits per country
  const limits: { [key: string]: number } = {
    US: 10,
    VE: 10,
    DO: 10,
    CU: 8,
    GT: 8,
    CR: 8,
  };
  const maxDigits = limits[country.toUpperCase()] || 15;

  // Truncate to max digits
  const truncatedDigits = digits.slice(0, maxDigits);

  // Format as-you-type
  return new AsYouType(country as any).input(truncatedDigits);
};

export const isValidPhone = (val: string, country: string): boolean => {
  try {
    return libIsValid(val, country as any);
  } catch (error) {
    return false;
  }
};

export const getPhonePlaceholder = (country: string): string => {
  try {
    const example = getExampleNumber(country.toUpperCase() as any, examples);
    if (example) {
      let formatted = example.formatNational();
      if (country.toUpperCase() === "VE") {
        formatted = formatted.replace(/^0/, "").replace(/[-\s]/g, "");
      } else if (country.toUpperCase() === "CU") {
        formatted = formatted.replace(/[-\s]/g, "");
      }
      return formatted;
    }
  } catch (error) {
    console.error("Error getting phone placeholder:", error);
  }
  return "Nro de teléfono";
};
